<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="saveReferral()" style="min-height: 300px">
    <!--min height so the referred by dropdown not hidden behind footer-->
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row mb-2" *ngIf="showProspectiveCandidate">
            <div class="col-4 d-flex align-items-center">
              <b>Prospective Candidate</b>
            </div>
            <div class="col-8">
              <input type="text" style="color: inherit !important;" name="prospectiveCandidateName" disabled="disabled" class="form-control" formControlName="prospectiveCandidateName" />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center">
              <b>New Hire</b>
            </div>
            <div class="col-8">
              <p-autoComplete *ngIf="disableNewHireName === false" [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" formControlName="selectedNewHire"
                              [suggestions]="userList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                              [minLength]="1" [autoHighlight]="true"
                              (onSelect)="selectNewHireStaff($event)" [forceSelection]="true"
                              (onClear)="clearNewHireStaff($event)"></p-autoComplete>
              <!--<input *ngIf="disableNewHireName" type="text" disabled="disabled" class="form-control mt-2" [(ngModel)]="prefixNewHireText" [ngModelOptions]="{standalone: true}" />-->
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center">
              <b>Referred By</b>
            </div>
            <div class="col-8">
              <p-autoComplete *ngIf="disableReferredByName === false" [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" formControlName="selectedReferredBy"
                              [suggestions]="userList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                              [minLength]="1" [autoHighlight]="true"
                              (onSelect)="selectReferredByStaff($event)" [forceSelection]="true"
                              (onClear)="clearReferredByStaff($event)"></p-autoComplete>
              <!--<input *ngIf="disableReferredByName" type="text" disabled="disabled" class="form-control mt-2" [(ngModel)]="prefixReferredByText" [ngModelOptions]="{standalone: true}" />-->
            </div>
          </div>

          <div class="row mb-2" *ngIf="employeeReferralId > 0 && newHireSelected">
            <div class="col-4 d-flex align-items-center">
              <b>Next Bonus Date</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="nextBonusDateString" />
              <app-validation-message [form]="form" [path]="'nextBonusDateString'" [label]="'Next Bonus Date'"></app-validation-message>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button class="btn btn-secondary" type="button" (click)="closeModal()">Cancel</button>
    <button class="btn btn-primary" type="submit" (click)="saveReferral()" [disabled]="disableButtons()">Save</button>
  </ng-template>
</p-dialog>
